var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWvIconLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 88.99 63.61",
    id: "wv-icon-home-logo__svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "wv-icon-home-logo",
    d: "M38.82,25.19V38.05a25.49,25.49,0,0,0,24.8,25.56,25.22,25.22,0,0,0,25.1-23c.2-1.91.27-6.82.27-8.75s-.07-6.84-.27-8.75A25.13,25.13,0,0,0,48.7,5a.65.65,0,0,0-.05.84l5.27,8.74a.52.52,0,0,0,.78.09h0a13.83,13.83,0,0,1,22.61,8.6,73.87,73.87,0,0,1,.36,8.58,76.75,76.75,0,0,1-.34,8.5A13.84,13.84,0,0,1,63.62,52.26h0a13.5,13.5,0,0,1-9.5-4.15,13.8,13.8,0,0,1-3.92-9.68V25.57A25.49,25.49,0,0,0,25.37,0,25.22,25.22,0,0,0,.27,23.05C.06,25,0,29.87,0,31.81s.06,6.83.27,8.75a25.14,25.14,0,0,0,40,18.11.68.68,0,0,0,.05-.85l-5.27-8.74a.52.52,0,0,0-.78-.09h0a13.83,13.83,0,0,1-22.62-8.59,76.16,76.16,0,0,1-.35-8.58,76.92,76.92,0,0,1,.34-8.51,13.87,13.87,0,0,1,13.71-12h0a13.5,13.5,0,0,1,9.5,4.15,13.85,13.85,0,0,1,3.92,9.69Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWvIconLogo);
export default __webpack_public_path__ + "static/media/wv-icon-logo.fc1313a5.svg";
export { ForwardRef as ReactComponent };